exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-editor__editable{min-height:300px;max-height:300px}", ""]);

// exports
